import { ROUTE_INVESTING_IDEA_MARKET } from '@/constants/routes';
import { GridViewOptions } from '../constants/constants';

export default function useDividendInvestingIdea(market: string) {
  if (market === '') return undefined;

  return {
    results: 0,
    linkToInvestingIdea: {
      type: ROUTE_INVESTING_IDEA_MARKET,
      payload: {
        id: GridViewOptions.GRID_VIEW_DIVIDEND_NEW,
        name: 'dividend-powerhouses-3-yield',
        market: market.toLowerCase(),
      },
    },
  };
}
